import React from "react";
import { Result, Button } from "antd";

export default function Mantenimiento() {
  return (
    <Result
      status="warning" // usa un status que sí tenga ícono
      title="503"
      subTitle="Estamos realizando mantenimiento. Por favor, intenta de nuevo más tarde."
      extra={
        <Button type="primary" href="/">
          Volver al inicio
        </Button>
      }
    />
  );
}
